// Production transport for YDocSyncProvider — binds a Y.Doc to the FxM chat backend:
// /docs REST (via api.ts) + the doc:{id} Centrifugo channel (via realtime.sharedSub).
// This is the spike's centrifugo-transport.ts specialized to the app's own api + the
// shared, ref-counted realtime client. Nothing here parses yjs — opaque base64 blobs.
import { api } from './api';
import { sharedSub } from './realtime';
import type { DocSyncTransport } from './ydoc-sync-provider';

// yjs updates are binary; base64 for JSON transport (matches the server's Text column).
export const b64encode = (u: Uint8Array): string => {
  let s = '';
  for (let i = 0; i < u.length; i += 1) s += String.fromCharCode(u[i]);
  return btoa(s);
};
export const b64decode = (b64: string): Uint8Array => {
  const s = atob(b64);
  const u = new Uint8Array(s.length);
  for (let i = 0; i < s.length; i += 1) u[i] = s.charCodeAt(i);
  return u;
};

/** A transport bound to one doc. `clientId` tags our sends so we skip our own echoes. */
export function chatDocTransport(docId: string, clientId: string): DocSyncTransport {
  return {
    clientId,
    async load(): Promise<Uint8Array[]> {
      const { updates } = await api.getDoc(docId);
      return (updates ?? []).map(b64decode);
    },
    async send(_docId: string, update: Uint8Array): Promise<void> {
      await api.pushDocUpdate(docId, b64encode(update), clientId);
    },
    subscribe(_docId: string, onRemote: (u: Uint8Array, origin?: string) => void): () => void {
      // sharedSub mints the per-channel token via api.subscribeToken — the backend now
      // authorizes doc:{id} by channel membership — and ref-counts the subscription.
      return sharedSub(`doc:${docId}`, (ctx: any) => {
        const d = ctx?.data;
        if ((d?.type === 'doc.update' || d?.type === 'doc.snapshot') && d.update) {
          onRemote(b64decode(d.update), d.origin);
        }
      });
    },
  };
}
